import React, { useState, useEffect } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
  FormControl,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Close from "../../../assets/icons/Close.svg";
import Autocomplete from "@mui/material/Autocomplete";
import GreyDownArrow from "../../../assets/icons/GreyDownArrow.svg";
import countries from "../../../utils/CountryCodeData";
import {
  addUserMasterList,
  setIsOpenModelAddUserMaster,
} from "../../../redux/actions/mastersAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

export const passwordGenerator = () => {
  return stringGen(4) + "@" + numberGen(4);
};
export const stringGen = (len) => {
  var text = "";
  var charset = "abcdefghijklmnopqrstuvwxyz";
  for (var i = 0; i < len; i++)
    text += charset.charAt(Math.floor(Math.random() * charset.length));
  return text;
};
export const numberGen = (len) => {
  var text = "";
  var charset = "0123456789";
  for (var i = 0; i < len; i++)
    text += charset.charAt(Math.floor(Math.random() * charset.length));
  return text;
};

const AddCompanyAdminModel = (Props) => {
  const dispatch = useDispatch();
  const isSaveButtonLoading = useSelector(
    (state) => state?.user?.isSaveButtonLoading
  );

  const CompanyID = localStorage.getItem("companyID");
  const CompanyAdminID = localStorage.getItem("CompanyAdminID");
  const uaeIndex = countries.findIndex((country) => country.label === "UAE");
  const defaultCountry = countries.find((country) => country.code === "AE");
  const [CountryCodeValue, setCountryCodeValue] = useState(
    defaultCountry?.phone
  );
  const AddCompanyAdminModel = useSelector(
    (state) => state?.masters?.models?.AddUserMasterModel
  );
  const handleChangeCountryCodeValue = (newValue) => {
    setCountryCodeValue(newValue?.phone);
  };

  const [CompanyAdminData, setCompanyAdminData] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    CompanyPhoneNo: "",
  });

  const handleChangeCompanyAdminData = (e) => {
    const { name, value } = e.target;
    // if (name === "CompanyPhoneNo") {
    //   const parsedPhoneNumber = new PhoneNumber(value);
    //   if (parsedPhoneNumber.isValid()) {
    //     setCompanyAdminData({ ...CompanyAdminData, [name]: value });
    //   }
    // } else {
    setCompanyAdminData({ ...CompanyAdminData, [name]: value });
    // }
  };

  const handleSaveCompanyAdmin = async (event) => {
    if (
      CompanyAdminData?.FirstName !== "" &&
      CompanyAdminData?.LastName !== "" &&
      CompanyAdminData?.Email !== "" &&
      CountryCodeValue !== undefined &&
      CompanyAdminData?.CompanyPhoneNo !== ""
    ) {
      const emailPattern =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (emailPattern.test(CompanyAdminData?.Email)) {
        dispatch(
          addUserMasterList({
            first_name: CompanyAdminData?.FirstName,
            last_name: CompanyAdminData?.LastName,
            email: CompanyAdminData?.Email,
            phone: "+" + CountryCodeValue + CompanyAdminData?.CompanyPhoneNo,
            username:
              CompanyAdminData?.FirstName?.toLowerCase() +
              "." +
              CompanyAdminData?.LastName?.toLowerCase(),
            company_id: CompanyID,
            role_id: CompanyAdminID,
            is_super_admin: "false",
            password: passwordGenerator(),
          })
        );
      } else {
        toast.error("Please enter valid Email ID");
      }
    } else {
      toast.error("Please enter all details to proceed");
    }
  };

  // const sortedCountries = [
  //   ...countries.slice(0, uaeIndex), // Countries before "UAE"
  //   countries[uaeIndex], // "UAE"
  //   ...countries.slice(uaeIndex + 1), // Countries after "UAE"
  // ];

  useEffect(() => {
    if (!AddCompanyAdminModel) {
      setCompanyAdminData({
        FirstName: "",
        LastName: "",
        Email: "",
        CompanyPhoneNo: "",
      });
    }
  }, [AddCompanyAdminModel]);

  countries.sort((a, b) => a.label.localeCompare(b.label));

  return (
    <Modal
      open={AddCompanyAdminModel}
      onClose={() => {
        dispatch(setIsOpenModelAddUserMaster(false));
        // setCompanyAdminData({
        //   FirstName: "",
        //   LastName: "",
        //   Email: "",
        //   CompanyPhoneNo: "",
        // });
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Add New Company Admin
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={() => {
                dispatch(setIsOpenModelAddUserMaster(false));
                // setCompanyAdminData({
                //   FirstName: "",
                //   LastName: "",
                //   Email: "",
                //   CompanyPhoneNo: "",
                // });
              }}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="First Name"
                name="FirstName"
                value={CompanyAdminData?.FirstName}
                onChange={handleChangeCompanyAdminData}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Last Name"
                name="LastName"
                value={CompanyAdminData?.LastName}
                onChange={handleChangeCompanyAdminData}
                sx={{
                  borderRadius: "10px",
                  width: "100%",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Email"
                name="Email"
                value={CompanyAdminData?.Email}
                onChange={handleChangeCompanyAdminData}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  borderRadius: "10px",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <Autocomplete
                id="country-select-demo"
                sx={{ width: 300 }}
                options={countries}
                defaultValue={defaultCountry}
                onChange={(event, newValue) =>
                  handleChangeCountryCodeValue(newValue)
                }
                autoHighlight
                getOptionLabel={(option) => "+" + option.phone}
                filterOptions={(options, state) => {
                  // Filter based on option.label
                  return options.filter((option) =>
                    option.label
                      .toLowerCase()
                      .includes(state.inputValue.toLowerCase())
                  );
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                    key={option.label}
                  >
                    <img
                      loading="lazy"
                      width="20"
                      srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                      src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                      alt=""
                    />
                    {option.label}
                    {/* ({option.code}) +{option.phone} */}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "100%",
                      borderRadius: "10px",
                      backgroundColor: "#F3F6F9",
                      borderRadius: "10px",
                      border: "none",
                      "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                        border: "0px solid #F3F6F9",
                        borderRadius: "10px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "& .MuiAutocomplete-clearIndicator": {
                        display: "none",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    placeholder="Select Country"
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password",
                    }}
                  />
                )}
              />
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Company Phone No"
                type="number"
                name="CompanyPhoneNo"
                value={CompanyAdminData?.CompanyPhoneNo}
                onChange={handleChangeCompanyAdminData}
                sx={{
                  width: "70%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .MuiInputBase-input": {
                    "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button":
                      {
                        "-webkit-appearance": "none",
                        margin: 0,
                      },
                    "-moz-appearance": "textfield",
                  },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Box>
              <Button
                sx={{
                  fontSize: "15px",
                  border: "1px solid #26875C",
                  fontWeight: 600,
                  width: "8rem",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                }}
                onClick={() => {
                  dispatch(setIsOpenModelAddUserMaster(false));
                  // setCompanyAdminData({
                  //   FirstName: "",
                  //   LastName: "",
                  //   Email: "",
                  //   CompanyPhoneNo: "",
                  // });
                }}
              >
                Cancel
              </Button>
            </Box>
            <Box>
              <LoadingButton
                onClick={handleSaveCompanyAdmin}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "8rem",
                  border: "1px solid #26875C",
                  backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
                loading={isSaveButtonLoading}
              >
                Save
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddCompanyAdminModel;
